(function () {
  if (window.__kmBlogAttributionLandingInitialized) return;
  window.__kmBlogAttributionLandingInitialized = true;

  var STORAGE_KEY = 'km_blog_attribution_v1';
  var LANDING_SEEN_PREFIX = 'km_blog_landing_seen:';
  var ATTRIBUTION_TTL_MS = 7 * 24 * 60 * 60 * 1000;

  function readAttribution() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function removeAttribution() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function isFresh(attribution) {
    if (!attribution || !attribution.ts) return false;
    var timestamp = Date.parse(attribution.ts);
    if (!timestamp) return false;
    return Date.now() - timestamp <= ATTRIBUTION_TTL_MS;
  }

  function getCurrentParam() {
    try {
      return new URL(window.location.href).searchParams.get('km_blog_cta') || '';
    } catch (error) {
      return '';
    }
  }

  function normalizePath(targetUrl) {
    if (!targetUrl) return '';

    try {
      return new URL(targetUrl, document.baseURI).pathname;
    } catch (error) {
      return '';
    }
  }

  function matchesCurrentLanding(attribution, ctaParam) {
    if (!attribution || !ctaParam || attribution.cta_id !== ctaParam) return false;

    var targetPath = normalizePath(attribution.cta_target_url);
    if (!targetPath) return true;

    return targetPath === window.location.pathname;
  }

  function seenLanding(key) {
    try {
      if (window.sessionStorage.getItem(key)) return true;
      window.sessionStorage.setItem(key, '1');
    } catch (error) {
      return false;
    }

    return false;
  }

  function pushEvent(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    var eventPayload = payload || {};
    eventPayload.event = eventName;
    window.dataLayer.push(eventPayload);
  }

  function updateCartAttributes(attribution) {
    if (!attribution || !attribution.commerce_eligible) return;

    var attributes = {
      blog_cta_ref: [attribution.article_handle, attribution.cta_id].filter(Boolean).join('|'),
      blog_cta_ts: attribution.ts || new Date().toISOString(),
      blog_article: attribution.article_handle || '',
      blog_session_id: attribution.session_id || '',
      blog_attribution_reason: attribution.attribution_reason || ''
    };

    try {
      window.fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function () {});
    } catch (error) {}
  }

  var ctaParam = getCurrentParam();
  if (!ctaParam) return;

  var attribution = readAttribution();
  if (!isFresh(attribution)) {
    removeAttribution();
    return;
  }

  if (!matchesCurrentLanding(attribution, ctaParam)) return;

  var seenKey = [
    LANDING_SEEN_PREFIX,
    attribution.cta_id || '',
    '|',
    window.location.pathname,
    '|',
    attribution.ts || ''
  ].join('');

  if (!seenLanding(seenKey)) {
    pushEvent('blog_cta_landing', {
      cta_context: 'blog',
      cta_type: attribution.cta_type || '',
      cta_id: attribution.cta_id || '',
      cta_action: attribution.cta_action || '',
      cta_target_url: attribution.cta_target_url || '',
      article_handle: attribution.article_handle || '',
      article_title: attribution.article_title || '',
      blog_handle: attribution.blog_handle || '',
      landing_path: window.location.pathname,
      product_id: attribution.product_id || '',
      product_handle: attribution.product_handle || '',
      variant_id: attribution.variant_id || '',
      commerce_eligible: Boolean(attribution.commerce_eligible),
      attribution_reason: attribution.attribution_reason || ''
    });
  }

  updateCartAttributes(attribution);
})();
